<template>
    <div>
        <el-drawer class="fxn-serviceitem" title=" " :visible.sync="drawer" :direction="direction" :before-close="handleClose" size="32rem" :append-to-body="true">
            <div class="fxn-serviceitem-wrap fxn-flex">
                <div class="fxn-flex-item">
                    <img src="../assets/img/fxn-tellphone.png" alt="">
                    <h3>软电话</h3>
                    <h4>（呼入呼出）</h4>
                    <p>一键呼叫、支持固话卡池</p>
                </div>
                <div class="fxn-flex-item">
                    <img src="../assets/img/fxn-sms.png" alt="">
                    <h3>短信/闪信</h3>
                    <h4>（内容备案）</h4>
                    <p>多模板触达、一键发送</p>
                </div>
                <div class="fxn-flex-item">
                    <img src="../assets/img/fxn-lv.png" alt="">
                    <h3>函件</h3>
                    <h4>（发本人）</h4>
                    <p>行权声明、律师函(催款)</p>
                </div>
                <div class="fxn-flex-item">
                    <img src="../assets/img/fxn-phoneno.png" alt="">
                    <h3>手机号状态</h3>
                    <h4>（正常|停机|空号）</h4>
                    <p>客户分类、号码清洗、高效过滤</p>
                </div>
            </div>
            <div class="fxn-serviceitem-info">
                <h3>开通服务热线</h3>
                <div class="fxn-flex">
                    <div class="fxn-flex-item"><i class="iconfont iconphone"></i>0769-21660075</div>
                    <div class="fxn-flex-item"><i class="iconfont iconperson"></i>客服专线: 0769-216663102、0769-21663021</div>
                    <div class="fxn-flex-item"><i class="iconfont iconemail"></i>客服邮箱：kefu@zhaiweishi.cn</div>
                </div>
            </div>
        </el-drawer>
    </div>
</template>

<script>
    export default {
        data(){
            return{
                drawer: false,
                direction: 'ttb',
            }
        },
        methods:{
            //关闭
            handleClose(){
                this.drawer = false;
            },
        },
        mounted(){
            //关闭--发送短信
            let that = this;
            this.OpenAside.$on('CloseService',function(type){
                that.drawer = true;
            })
            
        },
        beforeDestroy() {
            this.OpenAside.$off('CloseService')
        },
    }
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/ServiceItem.vue